export default __webpack_public_path__ + "images/d7697a9ad7448c6bf61f670ec80aa16e-menu-cat-feed.svg";